import { RouterLink } from "../../../../../../../components/router-link";

interface Props {
  catalogId: string;
  catalogVersionId: string;
  label: string;
}

export const CatalogVersionDetailLinkCell = ({ catalogId, label, catalogVersionId }: Props) => {
  return (
    <RouterLink
      params={{ catalogId, catalogVersionId }}
      to={"/app/catalogs/catalog/$catalogId/version/$catalogVersionId"}
      underline="hover"
    >
      {label}
    </RouterLink>
  );
};
